import Env from "config/environment";

const { isTestMarketingEnvironment, hostName } = Env;

export const marketingHost = Env.marketingHost;
export const reswareDocumentationHost = "https://notarize.com/knowledge-center/resware-notarize";
export const proofCapabilitiesUrl = "https://www.proof.com/capabilities/identity-verification";
export const notarizeAcademyUrl = `${marketingHost}/academy/real-estate-academy`;
export const paperRecordingBlogPost =
  "https://www.proof.com/blog/papering-out-recording-electronic-records";
export const legalInfoUrl = `${marketingHost}/legal`;
export const businessMarketingResourceUrl = `${marketingHost}/business-marketing-resource-center`;
export const notaryMarketingResourceUrl = "https://notarize.com/notary/resource-center";
export const notaryStateComplianceUrl = "https://www.notarize.com/compliance";
export const contactSalesUrl = "https://proof.com/contact";
export const tierPricingUrl = isTestMarketingEnvironment
  ? `${marketingHost}/pricing?env=${encodeURIComponent(hostName)}`
  : `${marketingHost}/pricing`;
export const titlePricingUrl = isTestMarketingEnvironment
  ? `${marketingHost}/pricing?env=${encodeURIComponent(hostName)}#title`
  : `${marketingHost}/pricing#title`;
export const lenderEligibilityTitlePricingUrl = isTestMarketingEnvironment
  ? `${marketingHost}/pricing?env=${encodeURIComponent(hostName)}&ref=lendereligibility#title`
  : `${marketingHost}/pricing?ref=lendereligibility#title`;
export const businessPricingUrl = isTestMarketingEnvironment
  ? `${marketingHost}/pricing?env=${encodeURIComponent(hostName)}#business`
  : `${marketingHost}/pricing#business`;
export const lenderPricingUrl = isTestMarketingEnvironment
  ? `${marketingHost}/pricing?env=${encodeURIComponent(hostName)}#loan`
  : `${marketingHost}/pricing#loan`;
export const proofLenderPricingUrl = isTestMarketingEnvironment
  ? `https://proof.com/pricing?env=${encodeURIComponent(hostName)}#mortgage`
  : "https://proof.com/pricing#mortgage";
export const mobileUrl = `${marketingHost}/mobile`;
export const notarizeNotaryUrl = "https://www.notarize.com/solutions/notaries";
export const proofDefendUrl = "https://www.proof.com/product/defend";
